import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  IonPage, IonHeader, IonFooter, IonToolbar, IonTitle, IonButtons, IonBackButton, IonContent,
  IonList, IonButton, IonIcon
} from '@ionic/react';
import { chevronBack, chevronForward } from 'ionicons/icons';

import { updateLog, clearLog } from 'actions/ProjectDataActions';
import { loadName } from 'helpers/loads';
import { ProjectContext } from 'components/layouts/Project';
import HelicalLog from './HelicalLog';
import PushPierLog from './PushPierLog';

export default function PileLog()  {
  const {loadId, ...params} = useParams();
  const pileNumber = parseInt(params.pileNumber, 10);
  const dispatch = useDispatch();
  const project = useContext(ProjectContext);
  const {data: {loads, logs}} = project ?? {};
  const load = _.find(loads, {id: loadId});
  const loadLabel = loadName(load, _.indexOf(loads, load));
  const log = _.get(logs, ['loads', loadId, 'piles', pileNumber]);
  const helical = load.pileType == 'helical';

  const updateLogFields = (fields) => dispatch(updateLog(loadId, pileNumber, fields));
  const clear = () => dispatch(clearLog(loadId, pileNumber));

  const Log = helical ? HelicalLog : PushPierLog;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref={`/projects/${project.id}/logs`}/>
          </IonButtons>
          <IonTitle>{loadLabel}: {helical ? 'Pile' : 'Pier'} <strong>{log?.pileNo ?? pileNumber}</strong></IonTitle>
          <IonButtons slot="end">
            <IonButton slot="end" color="warning" onClick={clear}>
              Clear
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div className="narrow-container">
          <IonList lines="full">
            <Log load={load} log={log} pileNumber={pileNumber} depthIncrement={logs.depthIncrement} updateLog={updateLogFields}/>
          </IonList>
        </div>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            {pileNumber > 1 && (
              <IonButton href={pileNumber - 1} color="secondary">
                <IonIcon icon={chevronBack}/> Previous Pile
              </IonButton>
            )}
          </IonButtons>
          <IonButtons slot="end">
            {pileNumber < load.pileCount ? (
              <IonButton href={pileNumber + 1} color="secondary">
                Next Pile <IonIcon icon={chevronForward}/>
              </IonButton>
            ) : (
              <IonButton href="../">
                Done
              </IonButton>
            )}
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}
